module.exports = __webpack_public_path__ + "img/ennetix-report-page.719c1e42.png";